// extracted by mini-css-extract-plugin
export default {"toolSelect":"index_toolSelect__Dzgyf","toolSelectContent":"index_toolSelectContent__4HdVy"};